module.exports = __webpack_public_path__ + "img/icon-info-circle.7bbc351a.svg";